export const ARTICLES_RESULT_LIMIT = 30;
export const PORTALS_RESULT_LIMIT = 5;
export const INITIAL_ARTICLES_LIMIT = 10;
export const SEARCH_QUERY_DEBOUNCE_TIME = 300;
export const REQUEST_FORMS_NEW_LIMIT = 15;
